import { Grid, Tooltip } from "@mui/material";
import {
  CheckboxInput,
  ModalWarning,
  PrimaryDeleteButton,
  PrimaryEditButton,
  PrimaryRestoreButton,
  PrimaryViewButton,
} from "components";

const TableAction = ({
  handleView,
  tooltipView,
  handleEdit,
  tooltipEdit,
  handleDelete,
  tooltipDelete,
  deleteConfirmation,
  deleteConfirmationTitle,
  deleteConfirmationContent,
  deleteConfirmationKey,
  handleRestore,
  tooltipRestore,
  restoreConfirmation,
  restoreConfirmationTitle,
  restoreConfirmationContent,
  restoreConfirmationKey,
  width,
  disabledView,
  disabledEdit,
  disabledDelete,
  disabledRestore,
  handleCheckbox,
  checked,
  customAction,
  tooltipCheckbox,
  disabledCheckbox,
}) => {
  return (
    <Grid container columnSpacing={1} width={width || 120} alignItems="center">
      {handleCheckbox && (
        <Tooltip title={tooltipCheckbox} placement="bottom">
          <Grid item>
            <CheckboxInput
              disabled={disabledCheckbox}
              color={disabledCheckbox && "gray"}
              checked={checked}
              onChange={disabledCheckbox ? null : e => handleCheckbox(e)}
            />
          </Grid>
        </Tooltip>
      )}
      {handleView && (
        <Grid item>
          <PrimaryViewButton
            onClick={handleView}
            tooltipTitle={tooltipView}
            disabled={disabledView}
          />
        </Grid>
      )}
      {handleEdit && (
        <Grid item>
          <PrimaryEditButton
            onClick={handleEdit}
            tooltipTitle={tooltipEdit}
            disabled={disabledEdit}
          />
        </Grid>
      )}
      {handleDelete && (
        <Grid item>
          <PrimaryDeleteButton
            onClick={
              deleteConfirmation
                ? () =>
                    ModalWarning(
                      typeof deleteConfirmationContent === "function"
                        ? deleteConfirmationContent()
                        : deleteConfirmationContent ||
                            `Are you sure you want to delete ${
                              deleteConfirmationKey
                                ? deleteConfirmationKey
                                : "this data"
                            } ?`,
                      typeof deleteConfirmationTitle === "function"
                        ? deleteConfirmationTitle()
                        : deleteConfirmationTitle || "Delete Data"
                    ).then(res => res?.isConfirmed && handleDelete())
                : handleDelete
            }
            tooltipTitle={tooltipDelete}
            disabled={disabledDelete}
          />
        </Grid>
      )}
      {handleRestore && (
        <Grid item>
          <PrimaryRestoreButton
            onClick={
              restoreConfirmation
                ? () =>
                    ModalWarning(
                      typeof restoreConfirmationContent === "function"
                        ? restoreConfirmationContent()
                        : restoreConfirmationContent ||
                            `Are you sure you want to delete ${
                              restoreConfirmationKey
                                ? restoreConfirmationKey
                                : "this data"
                            } ?`,
                      typeof restoreConfirmationTitle === "function"
                        ? restoreConfirmationTitle()
                        : restoreConfirmationTitle || "Delete Data"
                    ).then(res => res?.isConfirmed && handleRestore())
                : handleRestore
            }
            tooltipTitle={tooltipRestore}
            disabled={disabledRestore}
          />
        </Grid>
      )}
      {customAction && <Grid item>{customAction()}</Grid>}
    </Grid>
  );
};

export default TableAction;
